import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-sso-auth',
  templateUrl: './sso-auth.component.html',
  styleUrls: ['./sso-auth.component.css']
})
export class SsoAuthComponent implements OnInit {
  fragments:any={};

  constructor(private route:ActivatedRoute, private authService : AuthService) { }

  ngOnInit(): void {
    this.route.fragment.subscribe(
      fragment=>{
        this.fragments = fragment.split("&").reduce((a,c)=> (a[c.split("=")[0]] = c.split("=")[1],a)  ,{});
        this.auth();
      }
    )
  }

  auth(){
    let token = `${this.fragments['token_type']} ${this.fragments['access_token']}`
    let tokenType = this.fragments['token_type'];
    let pathwayType = this.fragments['type'] ? this.fragments['type'] :"";
    this.authService.ssoAuth(token,this.fragments['state'],tokenType,pathwayType)
  }

}
